import * as types from '../../../constants/actionTypes';
import * as api from '../../../tools/apiConfig';
import axios from 'axios';
// import {
// 	browserHistory
// } from 'react-router';
import {
	ToastContainer,
	toast
} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import * as url from '../../../tools/config';
// import openSocket from 'socket.io-client';
import {
	confirmAlert
} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

export function getAllSpecialists(data) {
	return function (dispatch, getState) {
		axios.post(api.GET_ALL_SPECIALISTS, JSON.stringify(data), {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({
						type: types.GET_ALL_SPECIALISTS,
						specialistList: response.data.data
					});
				} else {
					toast.error(response.data.message);
					response.data.data = {};
					response.data.data.success = false;
					return dispatch({
						type: types.GET_ALL_SPECIALISTS,
						specialistList: response.data.data ? response.data.data : {}
					});
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}

export function getAllPatients(data) {
	return function (dispatch, getState) {
		axios.post(api.GET_ALL_PATIENTS, JSON.stringify(data), {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({
						type: types.GET_ALL_PATIENTS,
						patientList: response.data.data
					});
				} else {
					toast.error(response.data.message);
					response.data.data = {};
					response.data.data.success = false;
					return dispatch({
						type: types.GET_ALL_PATIENTS,
						patientList: response.data.data ? response.data.data : {}
					});
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}

export function changeUserStatus(data) {
	return function (dispatch, getState) {
		axios.post(api.CHANGE_USER_STATUS, JSON.stringify(data), {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// return dispatch({
					// 	type: types.CHANGE_USER_STATUS,
					// 	patientList: response.data.data
					// });
					if (data.type == 'patient') {
						axios.post(api.GET_ALL_PATIENTS, JSON.stringify(data), {
							headers: {
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + localStorage.token
							}
						})
							.then(function (response) {
								if (response.data.code == 200) {
									return dispatch({
										type: types.GET_ALL_PATIENTS,
										patientList: response.data.data
									});
								} else {
									toast.error(response.data.message);
									response.data.data = {};
									response.data.data.success = false;
									return dispatch({
										type: types.GET_ALL_PATIENTS,
										patientList: response.data.data ? response.data.data : {}
									});
								}
							})
							.catch(function (error) {
								toast.error(error);
							});
					} else {
						delete data.status;
						data['status'] = data.verified
						axios.post(api.GET_ALL_SPECIALISTS, JSON.stringify(data), {
							headers: {
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + localStorage.token
							}
						})
							.then(function (response) {
								if (response.data.code == 200) {
									return dispatch({
										type: types.GET_ALL_SPECIALISTS,
										specialistList: response.data.data
									});
								} else {
									toast.error(response.data.message);
									response.data.data = {};
									response.data.data.success = false;
									return dispatch({
										type: types.GET_ALL_SPECIALISTS,
										specialistList: response.data.data ? response.data.data : {}
									});
								}
							})
							.catch(function (error) {
								toast.error(error);
							});
					}
				} else {
					toast.error(response.data.message);
					response.data.data = {};
					response.data.data.success = false;
					return dispatch({
						type: types.CHANGE_USER_STATUS,
						patientList: response.data.data ? response.data.data : {}
					});
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}